import React from 'react';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import DiskSizeTypeahead from './DiskSizeTypeahead';

export const DiskSize = ({
    fromDiskSize,
    toDiskSize,
    onChange,
    disabled,
    classes,
    t
}) => (
    <Box className={classes.specificationWrapper}>
        <InputLabel
            className={classes.inputLabelSpecification}
            shrink
            variant="standard"
        >
            {t('diskSize')}
        </InputLabel>
        <Box className={classes.SpecificationBox}>
            <FormControl
                fullWidth
                margin="dense"
                className={classes.formControlWrapper}
            >
                <DiskSizeTypeahead
                    animatedPlaceholder
                    labelId="from"
                    isClearable
                    name="from"
                    value={fromDiskSize}
                    onChangeSuggestion={onChange('fromDiskSizeTypes')}
                    disabled={disabled}
                    t={t}
                />

            </FormControl>
            <FormControl
                fullWidth
                margin="dense"
                className={classes.formControlWrapper}
            >
                <DiskSizeTypeahead
                    animatedPlaceholder
                    labelId="to"
                    isClearable
                    name="to"
                    value={toDiskSize}
                    onChangeSuggestion={onChange('toDiskSizeTypes')}
                    disabled={disabled}
                    t={t}
                />
            </FormControl>
        </Box>
    </Box>
);
